import { MATERIAL_SUMMARY_TABLE_NAME } from '../../material-summary/constants/material-summary.constants';
import {
    MATERIAL_SUMMARY_SHEET_HEADERS,
    materialSummaryRecordToCellValues,
} from '../../material-summary/utils/material-summary-record-to-cell-values.util';
import type { TabularSheetPayload } from '../../shared/tabular-sheet-payload.model';

/** Maps Get-Material-Summary records into a grid for {@link writeTabularSheetToWorksheet}. */
export function formatMaterialSummaryRecordsToTabularSheet(
    records: unknown[]
): TabularSheetPayload {
    return {
        columnHeaders: MATERIAL_SUMMARY_SHEET_HEADERS.map((h) => h.label),
        rows: records.map((record) => materialSummaryRecordToCellValues(record)),
        tableName: MATERIAL_SUMMARY_TABLE_NAME,
    };
}
